var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["job-display", { teaser: _vm.teaser }] }, [
    _c("div", { staticClass: "job-display--lines" }, [
      _c("div", { staticClass: "job-display--line" }, [
        _c(
          "div",
          { staticClass: "job-display--box" },
          [
            _c("h4", [_vm._v("Beschäftigungsarten")]),
            _vm._v(" "),
            _c("CharacteristicList", {
              attrs: { items: _vm.job.employmentMode }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.job.careerLevels
          ? _c(
              "div",
              { staticClass: "job-display--box" },
              [
                _c("h4", [_vm._v("Berufsebenen")]),
                _vm._v(" "),
                _c("CharacteristicList", {
                  attrs: { items: _vm.job.careerLevels }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "job-display--line" }, [
        _c(
          "div",
          { staticClass: "job-display--box" },
          [
            _c("h4", [_vm._v("Tätigkeiten und Aufgaben")]),
            _vm._v(" "),
            _c("SelectedItems", {
              staticClass: "no-left-padding",
              attrs: {
                "characteristic-items": _vm.meta.function,
                selected: _vm.functions,
                "show-additions": false,
                flat: ""
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "job-display--line" }, [
        _c(
          "div",
          { staticClass: "job-display--box" },
          [
            _c("h4", [_vm._v("Branchen")]),
            _vm._v(" "),
            !_vm.industrialSectors || _vm.industrialSectors.length === 0
              ? _c("div", [_vm._v("Alle Branchen möglich")])
              : _c("SelectedItems", {
                  staticClass: "no-left-padding",
                  attrs: {
                    "characteristic-items": _vm.meta.industrialSector,
                    selected: _vm.industrialSectors,
                    flat: ""
                  }
                })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }